import { StatusConfigs } from "./StatusPill.types";

// Map status to color name (not color value)
export const STATUS_CONFIGS: StatusConfigs = {
  user: {
    licensed: { color: "green" },
    unlicensed: { color: "purple" },
    archived: { color: "gray" },
    admin: { color: "white", backgroundColor: "dark-purple" },
    learner: { color: "white", backgroundColor: "teal" },
  },
  knowledgeAssessment: {
    complete: { color: "green" },
    notStarted: { color: "gray" },
    inProgress: { color: "blue" },
    overdue: { color: "purple" },
  },
};
